<template>
  <div class="store-sign baselayout">
    <div style="display: flex;">
        <div>
             <!-- 查询条件 -->
            <el-form
                :model="queryOrDownData" 
                :inline="true"
                size="mini"
                ref="searchForm">
                <el-form-item label="美团门店id:" label-width="100px">
                    <el-input placeholder="门店id" v-model="queryOrDownData.storeID" style="width:100px"></el-input>
                </el-form-item>
                <el-form-item label="门店类型:" label-width="100px">
                    <el-select v-model="queryOrDownData.storeType" placeholder="请选择门店类型" style="width: 100px;">
                        <el-option v-for="item in storeType" :key="item.value" :label="item.value" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="城市" label-width="50px">
                    <el-select
                        v-model="queryOrDownData.cityName"
                        filterable
                        placeholder="请选择城市"
                        style="width: 120px"
                    >
                        <el-option label="全国" value="" select>全国</el-option>
                        <el-option
                            v-for="item in cityData"
                            :key="item.code"
                            :label="item.name"
                            :value="item.name"
                        >
                        </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="签约人" label-width="80px">
                    <el-input placeholder="请填写签约人" v-model="queryOrDownData.signPeople" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="开始时间:" label-width="80px">
                    <el-date-picker
                        v-model="queryOrDownData.startTime"
                        type="date"
                        placeholder="开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间:" label-width="80px">
                    <el-date-picker
                        v-model="queryOrDownData.endTime"
                        type="date"
                        placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label-width="50px">
                    <el-button type="primary" @click="queryMarketList">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 下载 -->
            <el-button type="primary" @click="downMarketList" size="mini">下载签约列表</el-button>
            <el-button type="primary" @click="downloadUploadTemp" size="mini">下载上传模板</el-button>
        </div>
       
        <!-- 创建 -->
        <div style="margin-left:100px;margin-bottom: 20px;">
            <jx-upload-file
                :action="''"
                :drag="true"
                :multiple="false"
                :showFileList="false"
                :width="360"
                :height="100"
                :acceptType="'.xlsx'"
                v-model="marketSignList"  
            >
                <div class="el-upload__text" >拖拽<em>excel</em>到此处，或点击选择文件上传</div>
            </jx-upload-file>
        </div>
    </div>

    <el-table
        :data="tableData"
        style="width: 100%"
        tooltip-effect="dark"
        height="calc(100vh - 300px)"
        stripe
        >
        <el-table-column prop="storeID" label="门店id" align="center" header-align="center"></el-table-column>
        <el-table-column prop="storeName" label="门店名" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="codeName"  label="城市"  align="center" header-align="center"></el-table-column>
        <el-table-column prop="storeType" label="类型" align="center" header-align="center"></el-table-column>
        <el-table-column prop="salesVolume" label="销量" align="center" header-align="center"></el-table-column>
        <el-table-column prop="points" label="扣点" align="center" header-align="center"></el-table-column>
        <el-table-column prop="contractFee" label="收费" align="center" header-align="center"></el-table-column>
        <el-table-column prop="signStartTime" label="签约时间" width="180" align="center" header-align="center">
            <template slot-scope="scope">
                {{ excelTimeSwitch(scope.row.signStartTime) }}
            </template>
        </el-table-column>
        <el-table-column prop="signEndTime" label="结束时间" width="180" align="center" header-align="center">
            <template slot-scope="scope">
                {{ excelTimeSwitch(scope.row.signEndTime) }}
            </template>
        </el-table-column>
        <el-table-column prop="signPeople"  label="负责人" align="center" header-align="center"></el-table-column>
        <el-table-column prop="status" label="签约状态" align="center" header-align="center"></el-table-column>
        <el-table-column prop="remake" label="备注"  width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="reward" label="奖励状态" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="createCrowd" label="群状态" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="createCrowd" label="操作" width="180" align="center" header-align="center">
            <template slot-scope="scope">
                <el-button @click="deleteItem(scope.row)" type="danger" size="small">删除</el-button>
            </template>
        </el-table-column>
    </el-table>

     <!-- 分页  -->
    <div class="page" style="text-align: center;">
      <el-pagination @size-change="sizeChange" @current-change="handleCurrentChange" :page-sizes="[15, 30, 50]"
        :page-size.sync="queryOrDownData.size" layout="total, sizes, prev, pager, next" :current-page="queryOrDownData.page"
        :total="totalCount">
      </el-pagination>
    </div>
    <!-- 分页 -->
  </div>
</template>

<script>
import {  
    createSupermarketSign,
    getSupermarketSign,
    downSupermarketSign,
    deleteSignStore
    } from '@/apis/store'
import jxUploadFile from '@/components/cmp/uploadFile'
import { showLoad,hideLoad } from '@/tools/loading.js'
import { mapGetters } from "vuex";
import { json2Excel, importExcel2 } from '@/tools/excel.js'
export default {
    components:{
        jxUploadFile
    },
    data(){
        return {
             marketSignList:"",  // 超市签约列表
             queryOrDownData:{
                storeID:"",     // 美团门店id
                storeName:"",   // 美团门店名称
                startTime:"",   // 开始时间
                endTime:"",     // 结束时间
                cityName:"",    // 门店城市
                storeType:"",   // 门店类型
                signPeople:"",  // 签约人
                page:1,        // 页码
                size:30,        // 页数
             },
             storeType:[
                {
                    value:"百货"
                },
                {
                    value:"菜店" 
                },
                {
                    value:"菜市"
                },
                {
                    value:"超市"
                },
                {
                    value:"美妆"
                },
                {
                    value:"蔬菜"
                },
                {
                    value:"水果"
                },
                {
                    value:"药店"
                }
             ],
             tableData:[],
             page:1,            // 当前页
             totalCount:0       // 总数
        }
    },
    computed:{
        ...mapGetters({
            cityData:"jxStorePick/allCity"
        })
    },
    watch:{
        // 超市签约列表
        marketSignList:function (to,from) {
            // console.log('to,99999',to)
            let  signObj = []   // 创建参数
            to.forEach((item,index) => {
                signObj.push({
                    storeID:item['门店id']?String(item['门店id']):"",
                    storeName:item['店名'] ? '' +item['店名']:"",
                    codeName:item['城市'] ? '' + item['城市']:"",
                    storeType:item['类目'] ? '' + item['类目']:"",
                    salesVolume:item['大概销量'] ? item['大概销量']:0,
                    points:item['签约扣点'] ? item['签约扣点']:0,
                    contractFee:item['收费'] ? item['收费']:0,
                    signStartTime:new Date(item['签约时间']*24*3600*1000-2209161600000 - 8*3600*1000),
                    signEndTime:new Date(item['结束时间']*24*3600*1000-2209161600000 - 8*3600*1000),
                    signPeople:item['负责人'] ? '' + item['负责人']:"",
                    status:item['状态'] ? '' + item['状态']:"",
                    remake:item['备注'] ? '' + item['备注']:"",
                    reward:item['奖励状态'] ? '' + item['奖励状态']:"",
                    createCrowd:item['群状态'] ? '' + item['群状态']:""
                })

                if(index === to.length -1)  {
                    this.$confirm(`共有${to.length}条数据, 是否创建?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(() => {
                        // console.log('---',signObj)
                        this.submit(signObj)
                    })
                }
            })

           
            this.totalCount = signObj.length
            // this.tableData = signObj
            // console.log('signObj',signObj)
        }
    },
    created(){
        this.queryMarketList()
    },
    methods:{
        async deleteItem(row){
            await this.$confirm('是否删除', '提示', { type: 'warning' })
            await deleteSignStore(row.storeID)
            await this.queryMarketList()
            hideLoad()
            this.$message.success('删除成功')
        },
        excelTimeSwitch(time){
            if(!time) return ''
            const date = new Date(time);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}年${month}月${day}日`;
        },
        // 创建提交
        async submit(signObj){
                let form = new FormData()
                form.append('signObj', JSON.stringify(signObj))
                await createSupermarketSign(form)
                this.$message.success('创建成功')
                this.queryMarketList()
                hideLoad()
        },
        // 查询超市列表
        async queryMarketList(){
            showLoad()
            let startTime = this.queryOrDownData.startTime?new Date(this.queryOrDownData.startTime).getTime()/1000:''
            let endTime = this.queryOrDownData.endTime?new Date(this.queryOrDownData.endTime).getTime()/1000:''
            // console.log('查询超市列表',this.queryOrDownData)
            let form = new FormData()
            form.append('storeID', this.queryOrDownData.storeID)
            form.append('storeName', this.queryOrDownData.storeName)
            form.append('startTime', startTime)
            form.append('endTime', endTime)
            form.append('cityName', this.queryOrDownData.cityName)
            form.append('storeType', this.queryOrDownData.storeType)
            form.append('signPeople', this.queryOrDownData.signPeople)
            form.append('page', this.queryOrDownData.page)
            form.append('size', this.queryOrDownData.size)
             let  res = await getSupermarketSign(form)
             this.tableData = res.data
             this.totalCount = res.page
             hideLoad()
        },
        // 下载超市列表
        async downMarketList(){
            let obj = JSON.parse(JSON.stringify(this.queryOrDownData))
            delete obj.page
            delete obj.size
            let startTime = this.queryOrDownData.startTime?new Date(this.queryOrDownData.startTime).getTime()/1000:''
            let endTime = this.queryOrDownData.endTime?new Date(this.queryOrDownData.endTime).getTime()/1000:''
            let form = new FormData()
            form.append('storeID', this.queryOrDownData.storeID)
            form.append('storeName', this.queryOrDownData.storeName)
            form.append('startTime', startTime)
            form.append('endTime', endTime)
            form.append('cityName', this.queryOrDownData.cityName)
            form.append('storeType', this.queryOrDownData.storeType)
            form.append('signPeople', this.queryOrDownData.signPeople)
            await downSupermarketSign(form)
            hideLoad()
            this.$message.success('下载成功')
        },
        downloadUploadTemp(){
            let json = [
                {
                    门店id: '',
                    店名: '',
                    城市: '',
                    类目: '',
                    大概销量: '',
                    签约扣点: '',
                    收费: '',
                    签约时间: '2023年7月10日',
                    负责人: '',
                    状态: '',           // 签约状态
                    结束时间: '2026年7月25日',
                    备注: '',
                    奖励状态: '',
                    群状态: '',
                }
            ]
            // 下载表格
            json2Excel(json, '签约列表模板')
        },
        // 每页个数改变
        sizeChange() {
            this.$nextTick(async () => {
                this.afsOrderList = await this.queryMarketList()
            })
        },
        // 点击页码
        async handleCurrentChange(val) {
            this.page = val
            this.queryOrDownData.page = val
            await this.queryMarketList()
            document.querySelector('.el-table__body-wrapper').scrollTop = 0
        }
    }
}
</script>

<style lang="scss" scope>
    .box1 {
      border: 1px solid #ddd;
      border-radius: 5px;
      padding: 10px;
      margin: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/storemanager/storeSign/index.vue